import { render, staticRenderFns } from "./tabSetupNab.vue?vue&type=template&id=d8a50660&"
import script from "./tabSetupNab.vue?vue&type=script&lang=js&"
export * from "./tabSetupNab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports